import { Box, Modal, Typography, Button, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
// 1. Importe a função do seu arquivo de serviço
import { verificarAdmin } from '../../services/adminService'; // <-- AJUSTE O CAMINHO

export default function UserHistoryModal({ open, onClose, user }) {
  const isAdminFromStorage = JSON.parse(localStorage.getItem('isAdmin') || 'false');
  const [isAdmin, setIsAdmin] = useState(isAdminFromStorage);
  const [loadingAdminCheck, setLoadingAdminCheck] = useState(false);

  const logins = 12;
  const logouts = 12;
  const atendimentos = 5;

  useEffect(() => {
    // 2. A lógica de chamada foi simplificada
    const checkAdmin = async () => {
      if (!user?.id) return;

      setLoadingAdminCheck(true);
      try {
        // Agora apenas chamamos a função importada
        const isAdminResult = await verificarAdmin(user.id);
        setIsAdmin(isAdminResult);
      } catch (error) {
        // O erro já é tratado na função, mas podemos adicionar um log extra se quisermos
        console.error('Falha ao checar permissão de admin no componente.', error);
        setIsAdmin(false);
      } finally {
        setLoadingAdminCheck(false);
      }
    };

    if (open && user?.id) {
      checkAdmin();
    }
  }, [open, user]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Histórico de Acesso
        </Typography>
        {user && (
          <>
            <Typography>
              <strong>Nome:</strong> {user.nome}
            </Typography>
            <Typography>
              <strong>Email:</strong> {user.email}
            </Typography>
            <Typography>
              <strong>Logins:</strong> {logins}
            </Typography>
            <Typography>
              <strong>Logouts:</strong> {logouts}
            </Typography>
            <Typography>
              <strong>Atendimentos:</strong> {atendimentos}
            </Typography>
          </>
        )}

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
          {isAdmin ? (
            <Button variant="contained" color="primary">
              Gerenciar Usuários
            </Button>
          ) : (
            <Button variant="outlined" color="secondary">
              Perfil
            </Button>
          )}
          <Button onClick={onClose} variant="contained" color="inherit">
            Fechar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
